import { useUser } from '../contexts/user-profile';

export function useIsDemoSupportRole() {
  const { roles } = useUser();
  return roles.includes('Demo Support');
}
